import {
  BORDER,
  cardStyle,
  formatChf,
  formatPct,
  sectionStyle,
  sectionTitleStyle,
} from './analyseShared'

function ModelList({ title, items, variant }) {
  return (
    <div style={{ ...cardStyle, flex: 1, minWidth: 280 }}>
      <h3 style={{ fontSize: 13, fontWeight: 500, marginBottom: 16, color: 'var(--text-secondary)' }}>{title}</h3>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {!(items || []).length && (
          <li style={{ fontSize: 12, color: 'var(--muted)', padding: '8px 0' }}>Aucune tendance détectée sur cette période.</li>
        )}
        {(items || []).map((m) => (
          <li
            key={`${m.make}-${m.model}`}
            style={{
              display: 'flex',
              gap: 12,
              alignItems: 'center',
              padding: '12px 0',
              borderBottom: BORDER,
            }}
          >
            {m.image_url ? (
              <img
                src={m.image_url}
                alt=""
                style={{ width: 48, height: 36, objectFit: 'cover', borderRadius: 4, background: 'rgba(255,255,255,0.04)' }}
              />
            ) : (
              <div style={{ width: 48, height: 36, borderRadius: 4, background: 'rgba(255,255,255,0.04)' }} />
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {m.label}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>
                {formatChf(m.prix_median)} · {m.volume} annonces
              </div>
            </div>
            <div style={{ textAlign: 'right', fontSize: 12 }}>
              <div style={{ color: variant === 'up' ? '#86efac' : '#fca5a5' }}>{formatPct(m.variation_pct)}</div>
              {m.variation_chf != null && (
                <div style={{ color: 'var(--muted)', marginTop: 2 }}>
                  {m.variation_chf > 0 ? '+' : ''}
                  {m.variation_chf.toLocaleString('fr-CH')} CHF
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function SectionTendancesModeles({ data, loading, error }) {
  if (loading) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>2 — Tendances modèles</h2>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>Chargement…</p>
      </section>
    )
  }
  if (error) {
    return (
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>2 — Tendances modèles</h2>
        <p style={{ color: '#fca5a5', fontSize: 13 }}>{error}</p>
      </section>
    )
  }
  if (!data) return null

  return (
    <section style={sectionStyle}>
      <h2 style={sectionTitleStyle}>2 — Tendances modèles</h2>
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 28 }}>
        <ModelList title="Top movers (90 jours)" items={data.movers} variant="up" />
        <ModelList title="Top droppers (90 jours)" items={data.droppers} variant="down" />
      </div>
      {(data.alertes || []).length > 0 && (
        <div style={cardStyle}>
          <h3 style={{ fontSize: 13, fontWeight: 500, marginBottom: 14, color: 'var(--text-secondary)' }}>Alertes attention</h3>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
            {data.alertes.map((a, i) => (
              <li
                key={i}
                style={{
                  padding: '12px 0',
                  borderBottom: i < data.alertes.length - 1 ? BORDER : 'none',
                  fontSize: 13,
                  lineHeight: 1.5,
                  color: 'var(--text-secondary)',
                }}
              >
                <span style={{ marginRight: 8 }}>{a.icon}</span>
                {a.text}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  )
}
